import { render, staticRenderFns } from "./DescriptionLanguagesDialog.vue?vue&type=template&id=d6b09248&scoped=true&lang=pug&"
import script from "./DescriptionLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./DescriptionLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DescriptionLanguagesDialog.vue?vue&type=style&index=0&id=d6b09248&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b09248",
  null
  
)

export default component.exports